/** Ma tenant modul zapnuty? (osa entitlements) */
export function isModuleEnabled(policy, module) {
    return policy.entitlements.includes(module);
}
/**
 * Smi uzivatel provest akci?
 * Entitlement vitezi nad roli: vypnuty modul = NE, i kdyz role akci ma.
 * `module === undefined` znamena, ze akce neni vazana na modul (kontroluji se jen role).
 */
export function can(user, action, module, policy) {
    if (module !== undefined && !isModuleEnabled(policy, module))
        return false;
    return user.roles.some((role) => policy.grants[role]?.includes(action) ?? false);
}
//# sourceMappingURL=can.js.map